import React from 'react';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@/components/ui/tooltip';

const CELL_COLOR = {
  ok: 'bg-emerald-400',
  warning: 'bg-amber-400',
  error: 'bg-rose-500',
  unknown: 'bg-neutral-200',
};

const fmtHm = (iso) => {
  try {
    const d = new Date(iso);
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  } catch (_) { return ''; }
};

/**
 * 24h status strip. Renders one thin cell per 30-min bucket coloured by
 * the bucket's majority status. Shows a "Collecting history..." caption
 * when fewer than 4 buckets have any samples so a fresh install doesn't
 * look broken.
 */
export const IntegrationHistorySparkline = ({ integration, testId }) => {
  if (!integration) return null;
  const buckets = Array.isArray(integration.buckets) ? integration.buckets : [];
  const withData = integration.buckets_with_data || 0;
  if (buckets.length === 0) return null;
  if (withData < 4) {
    return (
      <div
        className="text-[10px] text-neutral-400 italic pt-1"
        data-testid={testId ? `${testId}-collecting` : undefined}
      >
        Collecting history...
      </div>
    );
  }
  return (
    <TooltipProvider delayDuration={80}>
      <div
        className="flex gap-[1px] h-1.5 rounded-sm overflow-hidden bg-neutral-100 mt-2"
        data-testid={testId}
      >
        {buckets.map((b, i) => {
          const key = `${b.start}-${i}`;
          const color = CELL_COLOR[b.majority_status] || CELL_COLOR.unknown;
          const label = `${fmtHm(b.start)} to ${fmtHm(b.end)} · ${b.majority_status} · ${b.sample_count} sample${b.sample_count === 1 ? '' : 's'}`;
          return (
            <Tooltip key={key}>
              <TooltipTrigger asChild>
                <span
                  className={`flex-1 min-w-[3px] cursor-default ${color}`}
                  aria-label={label}
                />
              </TooltipTrigger>
              <TooltipContent side="top" className="text-[11px]">
                {label}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};

export default IntegrationHistorySparkline;
